import React ,{useState, useEffect} from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { delCart } from '../redux/action/index'
// import emptycart from '../assets/emptycart.jpg'
import { NavLink } from 'react-router-dom'
const Cart = () => {

  // *******************************
  const state = useSelector((state) => state.handleCart);
  const [rupesFormat, setrupesFormat] = useState('');

  const dispatch = useDispatch()

  const handleClose = (item) => {
    dispatch(delCart(item))
  }

  const product = (product) => {

    return (
      <>
        <div className="px-4 my-5 bg-light rounded-3" key={product.id}>
          <div className="container">
            <button
              className="btn-close float-end py-3"
              aria-label="Close"
              onClick={() => handleClose(product)}
            ></button>
            <div className="row justify-content-center">
              <div className="col-md-4 py-2">
                <img
                  src={product.image}
                  alt={product.title}
                  height="200px"
                  width="180px"
                />
              </div>
              <div className="col-md-4 py-3">
                <h3>{product.title}</h3>
                <p className="lead  fw-bold text-secondary ">
            {rupesFormat}
            </p>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  const emptyCart = () => {
    return (
      <>
        <div className="px-4 my-5 bg-light rounded-3">
          <div className="container py-4 ">
            <div className="row">
              <img
                src="https://cdni.iconscout.com/illustration/premium/thumb/empty-cart-5521508-4610092.png"
                alt=" empty cart"
                height="500px"
                width="280px"
              />
              <p className='text-center fw-bold text-black '>Cart is Empty Please Select and Add Items From Product </p>
              {/* <h3 className='justify-content-center' >Your Cart is Empty</h3> */}
            </div>
          </div>
        </div>
      </>
    )
  }

  const button = () => {
    return (
      <>
      <div className="container">
        <div className="row">
        <div className="col-md-4"></div>
        <div className="col-md-4">
        <NavLink to="/checkout" className="btn btn-outline-dark px-5 py-2  fw-bold  mx-auto">Proceed To Checkout</NavLink>
        </div>
        <div className="col-md-4"></div>

        </div>
      </div>
      </>
    )
  }


  useEffect(() => {
    state.forEach((product) => {
      const result = product.price * 75.27;
      const formattedResult = result.toFixed(2);
      setrupesFormat(formattedResult + ' INR');
    });
  }, [state]);

  return (
    <div>
      {/* //looping staement */}
      {state.length === 0 && emptyCart()}
      {state.length !== 0 && state.map(product)}
      {state.length !== 0 && button()}
    </div>
  )
}

export default Cart
